import { useState, useContext } from "react";
import clsx from "clsx";
import { useSection } from "@tree-company/tree-query";
import { CheckmarkIcon } from "../icons";
import { LocaleContext } from "../../app";

export function RadioInput({ question, className, handleChange }) {
  const { value, options, title } = useSection(question);
  const { translate } = useContext(LocaleContext);
  const labelId = `${question.key}-label`;
  const [showError, setShowError] = useState(false);

  return (
    <fieldset
      aria-labelledby={labelId}
      className={clsx("card", "optin-field", "optin-field__column", className)}
    >
      <p id={labelId} className="optin-field__label-text card-title">
        {title}
      </p>
      <div className="optin-field__options">
        {options.map((option) => (
          <label
            key={option.value}
            className={clsx("optin-field__option", {
              "optin-field__option--selected": value === option.value,
            })}
          >
            <input
              type="radio"
              name={question.key}
              value={option.value}
              checked={value === option.value}
              onChange={(e) => {
                setShowError(false);
                handleChange(e, option.value);
              }}
              onInvalid={() => setShowError(true)}
              className="sr-only"
              required={question.settings.required}
            />
            {value === option.value && <CheckmarkIcon />}
            <span className="optin-field__option-text">{option.label}</span>
          </label>
        ))}
      </div>
      <p
        className={clsx("optin-field__error", {
          "optin-field__error--visible": showError,
        })}
      >
        {translate("optin.error.options")}
      </p>
    </fieldset>
  );
}
